import { useDateFormatter } from '@repo/utils/date';
import { lazy, Suspense } from 'react';

import { CustomerInfoWithLevel, CustomerLevelType } from '../../../../hooks/useCustomerOverview';
import { BannerContent } from '../BannerContent/BannerContent';

import styles from './Banner.module.css';

const LoyaltyPet = lazy(() => import('./banner-pets.svg'));

export interface BannerProps {
  isCustomerLoggedIn: boolean;
  customerInfo?: CustomerInfoWithLevel;
}

export const Banner = ({ isCustomerLoggedIn, customerInfo }: BannerProps) => {
  const formatDate = useDateFormatter();

  const getBannerVariant = (isCustomerLoggedIn: boolean, customerLevelType: CustomerLevelType) => {
    const bannerVariant = {
      notLogged: {
        title: 'loyalty-program.public-landing-page.banner.title.not-logged',
        subtitle: 'loyalty-program.public-landing-page.banner.subtitle.not-logged',
        joinButton: 'loyalty-program.public-landing-page.banner.join-button.not-logged',
        joinButtonNavigation: '/account/zooclub/dashboard',
        subtitleValues: { endDate: '' },
        variant: 'not-logged',
      },
      basic: {
        title: 'loyalty-program.public-landing-page.banner.title.basic',
        subtitle: 'loyalty-program.public-landing-page.banner.subtitle.basic',
        joinButton: 'loyalty-program.public-landing-page.banner.join-button.basic',
        subtitleValues: { endDate: '' },
        variant: 'basic',
      },
      premium: {
        title: 'loyalty-program.public-landing-page.banner.title.premium',
        subtitle: 'loyalty-program.public-landing-page.banner.subtitle.premium',
        subtitleValues: {
          endDate: customerInfo?.loyaltyLevel.endDate
            ? formatDate(customerInfo.loyaltyLevel.endDate)
            : '',
        },
        variant: 'premium',
      },
    };

    if (!isCustomerLoggedIn) return bannerVariant.notLogged;
    else if (customerLevelType === 'BASIC') return bannerVariant.basic;
    else return bannerVariant.premium;
  };

  const bannerVariant = getBannerVariant(
    isCustomerLoggedIn,
    customerInfo?.loyaltyLevel.type || 'BASIC',
  );

  return (
    <div className={styles.banner} data-testid="welcome-banner">
      <div className={styles.bannerBody}>
        <BannerContent bannerVariant={bannerVariant} isCustomerLoggedIn={isCustomerLoggedIn} />
      </div>
      <Suspense fallback={null}>
        <LoyaltyPet
          data-testid="loyalty-pets-image"
          title="Loyalty Pets"
          className={styles.image}
          aria-hidden
        />
      </Suspense>
    </div>
  );
};
